import { ChevronLeft, ChevronRight, Info } from "@tamagui/lucide-icons";
import { XStack } from "tamagui";

import { Button, Text } from "@/components";

export default function PanelHeader({
  question,
  info,
  index,
  total,
  onPrev,
  onNext,
  nextDisabled = false,
}: {
  question: string;
  /** Longer explanation, offered behind an icon so the question itself stays short. */
  info?: string;
  index: number;
  total: number;
  onPrev: () => void;
  onNext: () => void;
  nextDisabled?: boolean;
}) {
  return (
    <XStack
      alignItems="center"
      gap="$200"
      paddingBottom="$250"
      paddingHorizontal="$150"
    >
      <Text fontFamily="$serif" flex={1}>
        {question}
        {info ? (
          <>
            {" "}
            <Info
              size="$150"
              color="$iconSecondary"
              aria-label={info}
              accessibilityLabel={info}
            />
          </>
        ) : null}
      </Text>
      {total > 1 && (
        <XStack alignItems="center">
          <Button
            mode="tertiary"
            paddingHorizontal="$100"
            disabled={index === 0}
            onPress={onPrev}
            aria-label="Previous question"
          >
            <ChevronLeft size="$150" />
          </Button>
          <Text size="$sm" color="$textSecondary" textAlign="center">
            {index + 1} of {total}
          </Text>
          <Button
            mode="tertiary"
            paddingHorizontal="$100"
            disabled={index === total - 1 || nextDisabled}
            onPress={onNext}
            aria-label="Next question"
          >
            <ChevronRight size="$150" />
          </Button>
        </XStack>
      )}
    </XStack>
  );
}
